import {Card, CardContent, CardMedia, Stack, Typography} from "@mui/material";
import {WorkInstanceDocument} from "../../../../types/pj1dbApiWork";
import {pickImageUrl} from "../../../../utils/workUtil";
import {MODEL_BG_COLOR, WORK_ATTRS} from "../../../../constants/work";

export interface WorkInstanceListItemProps {
  work: WorkInstanceDocument;
}

export default function WorkInstanceListItem(props: WorkInstanceListItemProps) {
  return (
    <Card sx={{p: 0, m: 0, width: 240, height: '100%'}}>
      <CardMedia
        component="img"
        height="145"
        image={pickImageUrl(props.work)}
        alt={props.work.attr[WORK_ATTRS.description.key]}
        sx={{objectFit: "scale-down", backgroundColor: MODEL_BG_COLOR}}
      />
      <CardContent sx={{pt: 1, px: 1}}>
        <Stack gap={1}>
          <Typography variant="subtitle2" component='p' sx={{overflowWrap: 'break-word'}}>
            （説明）{props.work.attr[WORK_ATTRS.description.key]}
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  )
}
